export function statusTextForJob(job: sage.model.IJob): string {
    switch (job.job_state) {
        case "CANCELED":
            return "This job has been canceled";
        case "ERROR":
            return "This job has errored";
        case "FINISHED":
            return "This job has finished";
        case "RUNNING":
        case "SETTING_UP":
            return "This job is in progress.";
        default:
            return "This job is in an unknown state.";
    }
}

export function colorClassForJob(job: sage.model.IJob): string {
    switch (job.job_state) {
        case "CANCELED":
            return "warning";
        case "ERROR":
            return "danger";
        case "FINISHED":
            return "success";
        case "RUNNING":
        case "SETTING_UP":
            return "primary";
        default:
            return "This job is in an unknown state.";
    }
}

export function statusTextForJobSpent(job: sage.model.IJob): string {
    if (job.total_counted_time === null) {
        return "Pending";
    } else {
        return "Deducted";
    }
}

export function colorClassForJobSpent(job: sage.model.IJob): string {
    if (job.total_counted_time === null) {
        return "warning";
    } else {
        return "danger";
    }
}
